import { Typography } from '@mui/material';
import { getUser } from '../../helpers/token';
import React, { useState } from 'react';
import LoginButton from 'components/Header/LoginButton';

export default function JoinTfBox() {
  const [open, setOpen] = useState(false);

  const user = getUser();

  // Hide when logged in
  if (user) return <></>;

  return (
    <div className="tw-bg-primary-50 dark:tw-bg-primary-900 tw-h-full tw-w-full tw-px-8 tw-py-4 tw-rounded tw-mb-6">
      <Typography
        color="textPrimary"
        variant="h5"
        component="p"
        className="tw-font-bold tw-pb-3 tw-pt-2"
      >
        Ready to Blog & Earn?
      </Typography>
      <p>
        With TravelFeed, easily start your own travel blog and earn as you go.
        It&apos;s the smart platform for travelers who want to profit from their
        passion.{' '}
        <a
          className="tw-cursor-pointer"
          onClick={() => setOpen(true)}
          onKeyDown={() => setOpen(true)}
          role="button"
          tabIndex={0}
        >
          Create an account
        </a>
      </p>
      {open && (
        <LoginButton
          open={open}
          hideButtons
          onClickClose={() => setOpen(false)}
        />
      )}
    </div>
  );
}
